import {faReceipt} from '@fortawesome/free-solid-svg-icons';
import {faSearch} from '@fortawesome/free-solid-svg-icons/faSearch';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import gql from 'graphql-tag';
import 'moment/locale/fr';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {withApollo} from 'react-apollo';
import {Button, Image} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import styled from 'styled-components';
import config from '../../../config/app';
import {dateFormatFR} from '../../../utils';
import defaultBrand from '../../../common/assets/img/store.png';
import DataTable from '../../../common/components/Datatable/Datatable';
import Screen from '../../../common/components/layout/Screen';
import Metadata from '../../../common/components/Metadata';
import {
  FILTER_EXPRESSION_OPERATOR,
  FILTER_OPERATOR,
  USER_BRANDS_CUSTOM_QUERY, USER_BRANDS_ORDER_BY,
} from '../../../common/constants';
import SelectOrder from './BrandsReceiptsSelectOrder';
import AddReceiptUser from '../../ticket/components/AddReceiptUser';

const GRAPHQL_QUERY_USER_BRANDS = gql`
  query userBrands($criteria: CriteriaInput!, $customQuery: UserBrandsCustomQuery) {
    currentUser {
      id
      brands(criteria: $criteria, customQuery: $customQuery) {
        id
        rows {
          id
          name
          createdAt
          file {
            id
            key
            token
          }
          lastReceipt {
            id
            createdAt
          }
          receipts {
            id
            total
          }
        }
        total
      }
    }
  }
`;

const Span = styled.span`
  font-family: 'Segoe UI Bold', sans-serif;
`;

const imgStyle = {
  maxHeight: 40,
  maxWidth: 80,
  height: 'auto',
  width: 'auto',
};

class BrandsReceipts extends Component {

  state = {
    advancedFilters: null,
    orderBy: USER_BRANDS_ORDER_BY.LAST_RECEIPT,
  };

  onSearch = (search) => this.setState({
    advancedFilters: {
      operator: FILTER_EXPRESSION_OPERATOR.Or,
      filters: [{
        field: 'brand.id',
        operator: FILTER_OPERATOR.Like,
        value: `%${search}%`,
      },{
        field: 'brand.name',
        operator: FILTER_OPERATOR.Like,
        value: `%${search}%`,
      }],
    },
  });

  displayLastReceipt = (t, date) => {
    if (!date) {
      return t('none');
    }
    return dateFormatFR({date: date});
  };

  displayImage = ({cell}) => {
    const {id, name, file} = cell.value;
    const fileUrl = file ? config.api_file_brand + id + '?token=' + file.token : defaultBrand;
    return <Image src={fileUrl} alt={name} style={imgStyle}/>;
  };

  displayAction = (row) => {
    return (
      <Link to={'/admin/brand/' + row.id}>
        <Button className="btn-update">
          <FontAwesomeIcon icon={faSearch} color="#329aef" size="sm"/>
        </Button>
      </Link>);
  };

  columns = t => [
    {
      Header: '#',
      accessor: 'id',
    },
    {
      Header: t('logo'),
      Cell: this.displayImage,
      accessor: row => row,
    },
    {
      Header: t('brand'),
      accessor: 'name',
    },
    {
      Header: t('lastTicket'),
      Cell: ({cell}) => this.displayLastReceipt(t, cell.value),
      accessor: 'lastReceipt.createdAt',
    },
    {
      Header: t('ticketsNb'),
      accessor: 'receipts.total',
    },
    {
      Header: t('detail'),
      Cell: ({cell}) => this.displayAction(cell.value),
      accessor: row => row,
    },
  ];

  render() {

    const {t} = this.props;

    const advancedFilters = (
      <SelectOrder value={this.orderBy} onChange={e => this.setState({orderBy: e.target.value})}/>
    );

    return (
      <Screen
        header={<Metadata meta={t('meta')} title={t('title')}/>}
        leftTitle={
          <>
            <FontAwesomeIcon icon={faReceipt} color={'rgb(201,0,95)'}/>
            <Span className="route-name">{t('BrandsReceipts.title')}</Span>
          </>
        }
        rightTitle={<AddReceiptUser/>}
      >
        <DataTable
          query={GRAPHQL_QUERY_USER_BRANDS}
          keyResult="currentUser.brands"
          columns={this.columns(t)}
          onSearch={this.onSearch}
          advancedFilters={this.state.advancedFilters}
          additionalFilters={advancedFilters}
          customQuery={
            this.state.orderBy === USER_BRANDS_ORDER_BY.LAST_RECEIPT
              ? USER_BRANDS_CUSTOM_QUERY.OrderByLastReceipt
              : null
          }
          defaultSort={
            this.state.orderBy === USER_BRANDS_ORDER_BY.BRAND_NAME
              ? {field: 'name'}
              : null
          }
          fetchPolicy={'cache-and-network'}
        />
      </Screen>
    );
  }
}

BrandsReceipts.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withApollo(withTranslation('ticket')(BrandsReceipts));
